<template>
  <v-select
    :items="roles"
    :label="label"
    v-model="selected"
    :multiple="multi"
    item-text="DisplayName"
    item-value="ID"
  ></v-select>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
const moduleNamespace = 'roles'
export default {
  name: 'v-roles',
  props: {
    label: '',
    value: null,
    multi: false,
  },
  data() {
    return {
      selected: this.value,
    }
  },
  created() {
    this.getRole()
  },
  methods: {
    ...mapActions(moduleNamespace, ['getRole']),
  },
  computed: {
    ...mapGetters(moduleNamespace, ['roles']),
  },
  watch: {
    selected(val) {
      this.$emit('input', val)
    },
    value(val) {
      this.selected = val
    },
  },
}
</script>
<style>
</style>